module.exports = __webpack_public_path__ + "static/media/pla_saf_dri.05897d35.png";